import { createSelector } from 'reselect';

const reviewsSelector = createSelector(
  (state) => state.reviews,
  (reviews) => reviews,
);

export const isLoading = createSelector(
  reviewsSelector,
  (reviews) => reviews.isLoading,
);

export const isUpdating = createSelector(
  reviewsSelector,
  (reviews) => reviews.isUpdating,
);

export const list = createSelector(
  reviewsSelector,
  (reviews) => reviews.list,
);

export const error = createSelector(
  reviewsSelector,
  (reviews) => reviews.error,
);

export const success = createSelector(
  reviewsSelector,
  (reviews) => reviews.success,
);

export const replyFormId = createSelector(
  reviewsSelector,
  (reviews) => reviews.replyFormId,
);

export const nextPage = createSelector(
  reviewsSelector,
  (reviews) => reviews.nextPage,
);

export const cottage = createSelector(
  reviewsSelector,
  (reviews) => reviews.cottage,
);

export default reviewsSelector;
